import * as React from "react";
import LogIn from "./LogIn";

const LogInModalContainer: React.FC<{ children?: React.ReactNode }> = (
  props
) => <LogIn>{props.children}</LogIn>;

export default LogInModalContainer;
